<template>
  <div class="layout-dark">
    <!-- PC Navbar -->
    <nav class="dark-navbar" v-if="!isMobile">
      <div class="navbar-container">
        <div class="navbar-left">
          <a href="/" class="logo-section">
            <div class="logo-icon" v-if="!systemConfig.website_logo">
              <i class="el-icon-view"></i>
            </div>
            <img v-else :src="systemConfig.website_logo" alt="Logo" class="logo-image" />
            <span class="logo-text">{{ systemConfig.website_name || '2HVR' }}</span>
          </a>
          
          <div class="nav-links">
            <router-link to="/" class="nav-link" :class="{ active: $route.path === '/' }">
              <i class="el-icon-s-home"></i>
              探索
            </router-link>
            <router-link to="/hotRanking" class="nav-link" :class="{ active: $route.path === '/hotRanking' }">
              <i class="el-icon-trophy"></i>
              排行榜
            </router-link>
            <router-link to="/GetMqGame" class="nav-link" :class="{ active: $route.path === '/GetMqGame' }">
              <i class="el-icon-link"></i>
              游戏解析
            </router-link>
            <router-link v-if="isAdmin" to="/manage" class="nav-link" :class="{ active: $route.path === '/manage' }">
              <i class="el-icon-setting"></i>
              管理后台
            </router-link>
            <router-link v-if="isAgent || isAdmin" to="/agent" class="nav-link" :class="{ active: $route.path === '/agent' }">
              <i class="el-icon-goods"></i>
              代理后台
            </router-link>
          </div>
        </div>

        <div class="navbar-right">
          <!-- 影视资源站入口 -->
          <button class="nav-btn movie-btn" @click="openMovieSite" title="影视资源">
            <i class="el-icon-video-camera"></i>
            <span class="btn-text">影视</span>
            <div class="hot-badge">HOT</div>
          </button>

          <!-- 购买卡密 -->
          <button class="nav-btn purchase-btn" @click="showPurchaseDialog = true" title="购买卡密">
            <i class="el-icon-shopping-cart-2"></i>
            <span class="btn-text">购买</span>
          </button>

          <!-- 用户菜单 -->
          <template v-if="isLoggedIn">
            <button class="nav-btn vip-btn" @click="showVipDialog = true" title="VIP兑换">
              <i class="el-icon-medal"></i>
              <span class="btn-text">VIP</span>
            </button>
            
            <el-dropdown trigger="click" @command="handleCommand">
              <div class="user-avatar">
                <img :src="user.avatar || defaultAvatar" alt="avatar" />
              </div>
              <el-dropdown-menu slot="dropdown" class="dark-dropdown">
                <div class="dropdown-user-info">
                  <p class="user-name">{{ user.name }}</p>
                  <p class="user-type">{{ getUserTypeLabel() }}</p>
                  <p class="user-expiry" v-if="user.vipExpiry">{{ user.vipExpiry }}</p>
                </div>
                <el-dropdown-item command="changePassword">
                  <i class="el-icon-lock"></i>修改密码
                </el-dropdown-item>
                <el-dropdown-item command="logout">
                  <i class="el-icon-switch-button"></i>退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>

          <router-link v-else to="/login">
            <button class="nav-btn login-btn" title="登录">
              <i class="el-icon-user"></i>
              <span class="btn-text">登录</span>
            </button>
          </router-link>
        </div>
      </div>
    </nav>

    <!-- Mobile Header -->
    <header class="mobile-header" v-else>
      <button class="menu-btn" @click="sidebarVisible = true">
        <i class="el-icon-s-unfold"></i>
      </button>
      <a href="/" class="mobile-logo">
        <div class="logo-icon" v-if="!systemConfig.website_logo">
          <i class="el-icon-view"></i>
        </div>
        <img v-else :src="systemConfig.website_logo" alt="Logo" class="logo-image-mobile" />
        <span>{{ systemConfig.website_name || '2HVR' }}</span>
      </a>
      <div class="mobile-actions">
        <button class="icon-btn" @click="showMobileSearch = true">
          <i class="el-icon-search"></i>
        </button>
        <div class="user-avatar-small">
          <img :src="user.avatar || defaultAvatar" alt="avatar" />
        </div>
      </div>
    </header>

    <!-- Mobile Search Dialog -->
    <el-dialog
      :visible.sync="showMobileSearch"
      :fullscreen="true"
      class="mobile-search-dialog"
      :show-close="false"
    >
      <div class="mobile-search-container">
        <div class="mobile-search-header">
          <div class="mobile-search-input-wrapper">
            <i class="el-icon-search"></i>
            <input
              v-model="mobileSearchText"
              type="text"
              placeholder="搜索游戏..."
              class="mobile-search-input"
              ref="mobileSearchInput"
              @keyup.enter="handleMobileSearch"
            />
          </div>
          <button class="mobile-search-cancel" @click="showMobileSearch = false">取消</button>
        </div>
        <div class="mobile-search-hint">
          <p>输入游戏名称后按回车搜索</p>
        </div>
      </div>
    </el-dialog>

    <!-- Mobile Sidebar -->
    <el-drawer
      :visible.sync="sidebarVisible"
      direction="ltr"
      size="75%"
      class="dark-drawer"
      :modal-append-to-body="false"
    >
      <div class="mobile-menu">
        <router-link to="/" class="mobile-menu-item" @click.native="sidebarVisible = false">
          <i class="el-icon-s-home"></i>
          探索
        </router-link>
        <router-link to="/hotRanking" class="mobile-menu-item" @click.native="sidebarVisible = false">
          <i class="el-icon-trophy"></i>
          排行榜
        </router-link>
        <router-link to="/GetMqGame" class="mobile-menu-item" @click.native="sidebarVisible = false">
          <i class="el-icon-link"></i>
          游戏解析
        </router-link>
        <div class="mobile-menu-item movie-item" @click="openMovieSite">
          <i class="el-icon-video-camera"></i>
          影视资源
          <span class="hot-badge-mobile">HOT</span>
        </div>
        <router-link v-if="isAgent || isAdmin" to="/agent" class="mobile-menu-item" @click.native="sidebarVisible = false">
          <i class="el-icon-goods"></i>
          代理后台
        </router-link>
        <router-link v-if="isAdmin" to="/manage" class="mobile-menu-item" @click.native="sidebarVisible = false">
          <i class="el-icon-setting"></i>
          管理后台
        </router-link>
      </div>
    </el-drawer>

    <!-- Main Content -->
    <div class="main-content">
      <router-view @showVipDialog="handleClickShowVip"></router-view>
    </div>

    <!-- Mobile Bottom Navigation -->
    <nav class="mobile-bottom-nav" v-if="isMobile">
      <router-link to="/" class="bottom-nav-item" :class="{ active: $route.path === '/' }">
        <i class="el-icon-s-home"></i>
        <span>首页</span>
      </router-link>
      <router-link to="/hotRanking" class="bottom-nav-item" :class="{ active: $route.path === '/hotRanking' }">
        <i class="el-icon-trophy"></i>
        <span>排行</span>
      </router-link>
      <div class="bottom-nav-item center-btn">
        <div class="center-btn-inner">
          <i class="el-icon-star-on"></i>
        </div>
      </div>
      <router-link to="/GetMqGame" class="bottom-nav-item" :class="{ active: $route.path === '/GetMqGame' }">
        <i class="el-icon-link"></i>
        <span>解析</span>
      </router-link>
      <router-link to="/mine" class="bottom-nav-item" :class="{ active: $route.path === '/mine' }">
        <i class="el-icon-user"></i>
        <span>我的</span>
      </router-link>
    </nav>

    <!-- Dialogs -->
    <el-dialog
      title="购买卡密"
      :visible.sync="showPurchaseDialog"
      width="500px"
      class="dark-dialog"
    >
      <div v-loading="purchaseLoading" class="purchase-content">
        <div v-if="purchaseLinks.length === 0" class="empty-state">
          <i class="el-icon-info"></i>
          <p>暂无购买链接</p>
        </div>
        <div v-else class="purchase-links">
          <div
            v-for="(link, index) in purchaseLinks"
            :key="index"
            class="purchase-link-item"
            @click="openPurchaseLink(link.link)"
          >
            <div class="link-info">
              <h4>{{ link.name }}</h4>
              <p>{{ link.link }}</p>
            </div>
            <i class="el-icon-right"></i>
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="showPurchaseDialog = false">关闭</el-button>
        <el-button type="primary" @click="refreshPurchaseLinks">刷新</el-button>
      </span>
    </el-dialog>

    <el-dialog title="VIP卡密兑换" :visible.sync="showVipDialog" width="400px" class="dark-dialog">
      <el-form>
        <el-form-item label="卡密">
          <el-input v-model="cardId" placeholder="请输入VIP卡密"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="showVipDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmVip">确定兑换</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改密码" :visible.sync="showPasswordDialog" width="400px" class="dark-dialog">
      <el-form>
        <el-form-item label="原密码">
          <el-input v-model="passwordForm.oldPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="passwordForm.newPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input v-model="passwordForm.confirmPassword" type="password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="showPasswordDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmPassword">确定修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cardExchange, changePassword, logout, getSettings, getPublicSystemConfig } from "@/api";

export default {
  name: "LayoutDark",
  data() {
    return {
      isMobile: false,
      sidebarVisible: false,
      isLoggedIn: false,
      showVipDialog: false,
      showPasswordDialog: false,
      showPurchaseDialog: false,
      showMobileSearch: false,
      mobileSearchText: "",
      purchaseLoading: false,
      cardId: "",
      purchaseLinks: [],
      defaultAvatar: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Cdefs%3E%3ClinearGradient id='grad' x1='0%25' y1='0%25' x2='100%25' y2='100%25'%3E%3Cstop offset='0%25' style='stop-color:%233b82f6;stop-opacity:1' /%3E%3Cstop offset='100%25' style='stop-color:%2306b6d4;stop-opacity:1' /%3E%3C/linearGradient%3E%3C/defs%3E%3Ccircle cx='50' cy='50' r='50' fill='url(%23grad)' /%3E%3C/svg%3E",
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      user: {
        name: "测试用户",
        vipLevel: 0,
        vipExpiry: "",
        avatar: "",
      },
      systemConfig: {
        website_name: "2HVR",
        website_logo: ""
      }
    };
  },

  computed: {
    isAdmin() {
      return this.user && this.user.role === "admin";
    },
    isAgent() {
      return this.user && this.user.role === "agent";
    },
  },

  mounted() {
    this.isLoggedIn = localStorage.getItem("token") ? true : false;
    if (this.isLoggedIn) {
      this.user = JSON.parse(localStorage.getItem("userInfo"));
    }
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    this.loadSystemConfig();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },

  watch: {
    showPurchaseDialog(newVal) {
      if (newVal) {
        this.fetchPurchaseLinks();
      }
    },
    showMobileSearch(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (this.$refs.mobileSearchInput) {
            this.$refs.mobileSearchInput.focus();
          }
        });
      }
    },
  },

  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },

    async handleCommand(command) {
      if (command === "changePassword") {
        this.showPasswordDialog = true;
      }
      if (command === "logout") {
        try {
          await logout();
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          this.isLoggedIn = false;
          this.user = {};
          this.$router.push("/login");
        } catch (error) {
          console.log(error);
        }
      }
    },

    async fetchPurchaseLinks() {
      this.purchaseLoading = true;
      try {
        const domain = location.host;
        const response = await getSettings({ domain });
        if (response.data.purchase_link.length) {
          this.purchaseLinks = response.data.purchase_link;
        } else {
          this.purchaseLinks = [];
          this.$message.error("暂无购买链接");
        }
      } catch (error) {
        console.error("获取购买链接失败:", error);
        this.$message.error("获取购买链接失败");
      } finally {
        this.purchaseLoading = false;
      }
    },

    refreshPurchaseLinks() {
      this.fetchPurchaseLinks();
    },

    openPurchaseLink(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },

    confirmVip() {
      if (!this.cardId) {
        this.$message.warning("请输入卡密");
        return;
      }

      cardExchange({ cardId: this.cardId })
        .then(() => {
          this.showVipDialog = false;
          this.$message.success("兑换成功");
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          this.isLoggedIn = false;
          this.user = {};
          this.$router.push("/login");
          this.cardId = "";
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    confirmPassword() {
      const { oldPassword, newPassword, confirmPassword } = this.passwordForm;

      if (!oldPassword) {
        this.$message.error("原密码不能为空");
        return;
      }

      if (newPassword !== confirmPassword) {
        this.$message.error("两次输入的密码不一致");
        return;
      }

      if (oldPassword === newPassword) {
        this.$message.error("新密码不能与原密码相同");
        return;
      }

      changePassword(this.passwordForm)
        .then((response) => {
          if (response.code === 200) {
            this.$message.success("密码修改成功");
            this.showPasswordDialog = false;
            localStorage.removeItem("token");
            localStorage.removeItem("userInfo");
            this.isLoggedIn = false;
            this.user = {};
            this.$router.push("/login");
            this.passwordForm = {
              oldPassword: "",
              newPassword: "",
              confirmPassword: "",
            };
          } else {
            this.$message.error(response.message);
          }
        })
        .catch((error) => {
          console.error("修改密码失败:", error);
          this.$message.error("修改密码失败");
        });
    },

    handleClickShowVip() {
      this.showPurchaseDialog = true;
    },

    openMovieSite() {
      window.open('https://pan.365wp.top/', '_blank');
    },

    async loadSystemConfig() {
      try {
        const domain = location.host;
        console.log('Loading system config for domain:', domain);
        const response = await getPublicSystemConfig({ domain });
        console.log('System config response:', response);
        if (response.data) {
          this.systemConfig = response.data;
          console.log('System config loaded:', this.systemConfig);
        }
      } catch (error) {
        console.error('加载系统配置失败:', error);
      }
    },

    getUserTypeLabel() {
      if (this.user.vipLevel == 0) {
        return "普通用户";
      }
      if (this.user.vipLevel == 9) {
        if (this.user.vipType === 'basic') {
          return "魔趣解析永久会员";
        } else if (this.user.vipType === 'premium') {
          return "全能高级永久会员";
        } else {
          return "永久会员";
        }
      }
      if (this.user.vipType === 'basic') {
        return "魔趣解析会员";
      } else if (this.user.vipType === 'premium') {
        return "全能高级会员";
      } else {
        return "会员用户";
      }
    },

    handleMobileSearch() {
      if (this.mobileSearchText.trim()) {
        this.showMobileSearch = false;
        this.$router.push({ path: '/', query: { search: this.mobileSearchText.trim() } });
        this.mobileSearchText = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/dark-theme.scss";

.layout-dark {
  min-height: 100vh;
  background: $dark;
}

// PC Navbar
.dark-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  @include glass-effect;
  border-bottom: $border-light;
  height: 64px;
}

.navbar-container {
  max-width: 100%;
  height: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  
  @media (min-width: 1400px) {
    max-width: 1400px;
    padding: 0 24px;
  }
  
  @media (max-width: 1399px) {
    padding: 0 20px;
  }
}

.navbar-left {
  display: flex;
  align-items: center;
  gap: 32px;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  transition: $transition-normal;

  &:hover {
    transform: scale(1.05);
  }
}

.logo-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: $gradient-primary;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
}

.logo-image {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  object-fit: cover;
}

.logo-text {
  font-size: 20px;
  font-weight: 700;
  @include gradient-text;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 12px;
  color: $slate-300;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: $transition-normal;

  i {
    font-size: 16px;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: white;
  }

  &.active {
    background: rgba(255, 255, 255, 0.1);
    color: white;
  }
}

.navbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.theme-switch-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: $border-lighter;
  color: $slate-300;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: $transition-normal;

  i {
    font-size: 16px;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: white;
  }
}

.search-box {
  position: relative;
  
  i {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: $slate-400;
  }
  
  input {
    width: 200px;
    padding: 8px 12px 8px 36px;
    background: rgba(255, 255, 255, 0.05);
    border: $border-lighter;
    border-radius: 20px;
    color: white;
    font-size: 14px;
    transition: $transition-normal;

    &::placeholder {
      color: $slate-400;
    }

    &:focus {
      outline: none;
      background: rgba(255, 255, 255, 0.1);
      border-color: $primary;
      width: 240px;
    }
  }
  
  @media (max-width: 1200px) {
    input {
      width: 160px;
      
      &:focus {
        width: 200px;
      }
    }
  }
}

.nav-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 20px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: $transition-normal;
  white-space: nowrap;

  i {
    font-size: 16px;
    flex-shrink: 0;
  }
  
  .btn-text {
    @media (max-width: 1200px) {
      display: none;
    }
  }
  
  @media (max-width: 1200px) {
    padding: 8px 10px;
    gap: 0;
  }
}

.purchase-btn {
  background: rgba(103, 194, 58, 0.1);
  color: #67c23a;
  border: 1px solid rgba(103, 194, 58, 0.3);

  &:hover {
    background: rgba(103, 194, 58, 0.2);
  }
}

.vip-btn {
  background: rgba(255, 187, 51, 0.1);
  color: #ffbb33;
  border: 1px solid rgba(255, 187, 51, 0.3);

  &:hover {
    background: rgba(255, 187, 51, 0.2);
  }
}

.movie-btn {
  position: relative;
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%);
  color: white;
  border: none;
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(255, 107, 107, 0.4);
  }

  .hot-badge {
    position: absolute;
    top: -6px;
    right: -6px;
    background: #ff3742;
    color: white;
    font-size: 10px;
    padding: 2px 6px;
    border-radius: 8px;
    font-weight: bold;
    line-height: 1;
    box-shadow: 0 2px 8px rgba(255, 55, 66, 0.5);
  }
}

.login-btn {
  background: $gradient-primary;
  color: white;

  &:hover {
    opacity: 0.9;
  }
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: $transition-normal;

  &:hover {
    border-color: $primary;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

// Mobile Header
.mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 56px;
  @include glass-effect;
  border-bottom: $border-light;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.menu-btn,
.icon-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  transition: $transition-normal;

  &:active {
    background: rgba(255, 255, 255, 0.1);
  }
}

.mobile-logo {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  
  .logo-icon {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }
  
  .logo-image-mobile {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    object-fit: cover;
  }
  
  span {
    font-size: 18px;
    font-weight: 700;
    color: white;
  }
}

.mobile-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar-small {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

// Mobile Sidebar
.mobile-menu {
  padding: 20px 0;
}

.mobile-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  color: $slate-300;
  text-decoration: none;
  font-size: 16px;
  transition: $transition-normal;

  i {
    font-size: 20px;
  }

  &:active {
    background: rgba(255, 255, 255, 0.05);
  }

  &.movie-item {
    position: relative;
    background: linear-gradient(135deg, rgba(255, 107, 107, 0.1) 0%, rgba(255, 142, 83, 0.1) 100%);
    border-left: 3px solid #ff6b6b;
    color: #ff8e53;
    cursor: pointer;

    .hot-badge-mobile {
      position: absolute;
      right: 20px;
      background: #ff3742;
      color: white;
      font-size: 10px;
      padding: 2px 8px;
      border-radius: 8px;
      font-weight: bold;
    }
  }
}

// Main Content
.main-content {
  padding-top: 64px;
  width: 100%;
  margin: 0;

  @media (max-width: 768px) {
    padding-top: 56px;
    padding-bottom: 70px;
  }
}

// Mobile Bottom Navigation
.mobile-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 64px;
  @include glass-effect;
  border-top: $border-light;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 8px;
}

.bottom-nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex: 1;
  height: 100%;
  color: $slate-400;
  text-decoration: none;
  font-size: 11px;
  transition: $transition-normal;

  i {
    font-size: 22px;
  }

  &.active {
    color: $primary;
  }

  &.center-btn {
    position: relative;
    top: -16px;
  }
}

.center-btn-inner {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: $gradient-primary;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  box-shadow: 0 4px 12px rgba($primary, 0.4);
}

// Dropdown
.dropdown-user-info {
  padding: 20px;
  border-bottom: $border-lighter;
  background: rgba(139, 92, 246, 0.05);

  p {
    margin: 0;
    color: $slate-400;
    font-size: 13px;
    line-height: 1.8;
  }

  .user-name {
    font-weight: 700;
    color: white;
    font-size: 17px;
    margin-bottom: 4px;
  }

  .user-type {
    color: $primary;
    font-weight: 600;
    font-size: 14px;
  }

  .user-expiry {
    color: $slate-500;
    font-size: 12px;
    margin-top: 4px;
  }
}

// Dialogs
.purchase-content {
  min-height: 200px;
}

.empty-state {
  text-align: center;
  padding: 40px 0;
  color: $slate-400;

  i {
    font-size: 48px;
    margin-bottom: 16px;
    display: block;
  }
}

.purchase-links {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.purchase-link-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: rgba(255, 255, 255, 0.05);
  border: $border-lighter;
  border-radius: 12px;
  cursor: pointer;
  transition: $transition-normal;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: $primary;
  }

  .link-info {
    flex: 1;
    min-width: 0;

    h4 {
      margin: 0 0 4px 0;
      color: white;
      font-size: 16px;
    }

    p {
      margin: 0;
      color: $slate-400;
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  i {
    color: $slate-400;
    font-size: 18px;
  }
}

// Dark Drawer
:deep(.dark-drawer) {
  .el-drawer {
    background: $card;
  }
}

// Dark Dialog
:deep(.dark-dialog) {
  .el-dialog {
    background: $card;
    border: $border-light;
  }

  .el-dialog__header {
    border-bottom: $border-lighter;
  }

  .el-dialog__title {
    color: white;
  }

  .el-dialog__close {
    color: $slate-400;

    &:hover {
      color: white;
    }
  }

  .el-form-item__label {
    color: $slate-300;
  }

  .el-input__inner {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.1);
    color: white;

    &::placeholder {
      color: $slate-400;
    }
  }
}

// Dark Dropdown
:deep(.dark-dropdown) {
  background: $card !important;
  border: $border-light !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4) !important;
  padding: 0 !important;
  margin-top: 8px !important;

  .popper__arrow {
    display: none !important;
  }

  .el-dropdown-menu__item {
    color: $slate-300 !important;
    padding: 12px 20px !important;
    font-size: 14px !important;
    transition: $transition-normal !important;
    background: transparent !important;

    &:hover {
      background: rgba(139, 92, 246, 0.1) !important;
      color: white !important;
    }

    &:not(:last-child) {
      border-bottom: $border-lighter !important;
    }

    i {
      margin-right: 10px !important;
      font-size: 16px !important;
      color: $slate-400 !important;
    }

    &:hover i {
      color: $primary !important;
    }
  }
}

// Mobile Search Dialog
:deep(.mobile-search-dialog) {
  .el-dialog {
    background: $dark !important;
    margin: 0 !important;
  }

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
    height: 100vh;
  }
}

.mobile-search-container {
  padding: 16px;
  padding-top: calc(env(safe-area-inset-top, 16px) + 56px);
}

.mobile-search-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mobile-search-input-wrapper {
  flex: 1;
  position: relative;
  
  i {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: $slate-400;
    font-size: 18px;
  }
}

.mobile-search-input {
  width: 100%;
  padding: 12px 16px 12px 44px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  color: white;
  font-size: 16px;
  outline: none;
  transition: all 0.2s ease;

  &::placeholder {
    color: $slate-400;
  }

  &:focus {
    border-color: $primary;
    background: rgba(255, 255, 255, 0.1);
  }
}

.mobile-search-cancel {
  background: none;
  border: none;
  color: $primary;
  font-size: 16px;
  font-weight: 500;
  padding: 8px;
  cursor: pointer;
  white-space: nowrap;
}

.mobile-search-hint {
  margin-top: 24px;
  text-align: center;
  
  p {
    color: $slate-500;
    font-size: 14px;
    margin: 0;
  }
}
</style>

<style lang="scss">
// 全局样式覆盖 - 不使用 scoped，确保能覆盖 Element UI 的下拉菜单
@import "@/styles/dark-theme.scss";

.el-dropdown-menu.dark-dropdown {
  background: $card !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4) !important;
  padding: 0 !important;

  .popper__arrow {
    display: none !important;
  }

  .el-dropdown-menu__item {
    color: #cbd5e1 !important;
    padding: 12px 20px !important;
    font-size: 14px !important;
    background: transparent !important;

    &:hover {
      background: rgba(139, 92, 246, 0.1) !important;
      color: white !important;
    }

    &:not(:last-child) {
      border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
    }

    i {
      margin-right: 10px !important;
      font-size: 16px !important;
      color: #94a3b8 !important;
    }

    &:hover i {
      color: #8b5cf6 !important;
    }
  }
}

.dropdown-user-info {
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  background: rgba(139, 92, 246, 0.05);

  p {
    margin: 0;
    color: #cbd5e1 !important;
    font-size: 13px;
    line-height: 1.8;
  }

  .user-name {
    font-weight: 700;
    color: white !important;
    font-size: 17px;
    margin-bottom: 4px;
  }

  .user-type {
    color: #8b5cf6 !important;
    font-weight: 600;
    font-size: 14px;
  }

  .user-expiry {
    color: #94a3b8 !important;
    font-size: 12px;
    margin-top: 4px;
  }
}
</style>
